// JAR7D scroll reveal
document.addEventListener('DOMContentLoaded', function() {
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('j-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.j-reveal').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.j-reveal').forEach(function(el) { el.classList.add('j-visible'); });
  }

  // Mobile nav toggle (works with Dawn's existing header)
  var toggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var closeBtn = document.querySelector('.mobile-nav-close');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() { mobileNav.classList.add('open'); });
  }
  if (closeBtn && mobileNav) {
    closeBtn.addEventListener('click', function() { mobileNav.classList.remove('open'); });
  }
});
